import AppConfirmDialog from '../../../../components/ui/AppConfirmDialog';
import { exportToCSV, exportToPDF } from '../../../../utils/exportUtils';
import React, { useRef,  useState  } from 'react';
import AppCard from '../../../../components/ui/AppCard';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import AddNewProducts from '../../../../features/policies/components/products/AddNewProduct.jsx';
import ViewProduct from '../../../../features/policies/components/products/ViewProduct.jsx';
import EditProduct from '../../../../features/policies/components/products/EditProduct.jsx';
import { useMountEffect } from 'primereact/hooks';
import apiClient from "../../../../services/api-client";
import StorageHelper from '../../../../utils/storage-helper';
        

export default function ProductList() {
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const [visible, setVisible] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [productsAvailable, setActiveProducts] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [termAndConditions, setTermAndConditions] = useState('')
  const [groupImageBannerUrl, setGroupImageBannerUrl] = useState('')
  const renderActions = (rowData) => {
  

  return (
      <div className="actions-container flex items-center justify-center gap-2">
        <div className="tooltip" data-tip="View">
          <button
            className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
            onClick={() => {
              setViewVisible(true);
              setSelectedRowData(rowData);
            }}
          >
            <i className="pi pi-eye text-lg"></i>
          </button>
        </div>
        <div className="tooltip" data-tip="Edit">
          <button
            className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
            onClick={() => {
              setEditVisible(true);
              setSelectedRowData(rowData);
            }}
          >
            <i className="pi pi-pencil text-lg"></i>
          </button>
        </div>
        <div className="tooltip" data-tip="Delete">
          <button
            className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
            onClick={() => {
              setSelectedRowData(rowData);
              document.getElementById('confirm_delete_group_modal').showModal();
            }}
          >
            <i className="pi pi-times text-lg"></i>
          </button>
        </div>
      </div>
    );
  };

  async function fetchAllProducts() {
    
    let activeProducts = []
    await apiClient.get('policy/products/active', {
      headers: {
        Authorization: 'Bearer ' + StorageHelper.get('token'),
        'Content-Type': 'application/json'
      }
    }).then((response) => {

        let products = response.data.responseBody

        products.forEach(product => {

            activeProducts.push(product)
        });
        setTermAndConditions (response.data.responseBody.termAndConditions)
        setGroupImageBannerUrl (response.data.responseBody.groupImageBannerUrl)
        console.log(response.data.responseBody)
    });

    setActiveProducts(activeProducts);
  }

  useMountEffect(() => {
    fetchAllProducts()
});

  const cols = [
     { field: 'index', header: '#' },
    { field: 'groupImageBannerUrl', header: 'Artwork' },
    { field: 'easipolSubGroupId', header: 'Group ID' },
    { field: 'activeStatus', header: 'Status' },
    { field: 'easipolPolicySubGroup.Description', header: 'Name' },
    { field: 'easipolPolicySubGroup.planProducts', header: 'No of Products' },
    { field: 'category', header: 'Category' },
    { field: 'activeStatus', header: 'is Active' },
    // { field: 'easipolPolicySubGroup.CommunicationContactNumber', header: 'Contact Number' },
    { field: 'actions', header: 'Actions' },

  ];
  const imageBodyTemplate = (url) => { 
    return <img src={url.groupImageBannerUrl} alt="No Group Artwork" className="w-2rem shadow-2 border-round" style={{ width: '80%' }} />;
  };

  const productCounter = (url) => {
    //console.log(url.planProducts)
    return <>{url?.planProducts.length} </>;
  };
  const viewProductTemplate = (rowData)=>{
    return (
      <Dialog header="" visible={viewVisible}  maximizable style={{ width: '80vw' }} onHide={() => setViewVisible(false)}>
            <div>
                <ViewProduct rowData={rowData} onCloseDialog={handleViewProduct} style={{ marginTop: '20px' }} />
            </div>
      </Dialog>
    )
  }

  const editProductTemplate = (rowData)=>{
    return (
      <Dialog header="" visible={editVisible}  maximizable style={{ width: '50vw' }} onHide={() => setEditVisible(false)}>
            <div>
                <EditProduct rowData={rowData} termAndConditions={termAndConditions} groupImageBannerUrl={groupImageBannerUrl} onCloseDialog={handleViewProduct} style={{ marginTop: '20px' }} />
            </div>
      </Dialog>
    )
  }

  const addNewProductTemplate = ()=>{
    return(
      <Dialog header="Add New Product Group" visible={visible}  maximizable style={{ width: '30vw' }} onHide={() => setVisible(false)}>
            <div>
                <AddNewProducts  onCloseDialog = { handleAddProduct} style={{ marginTop: "20px;"}} />
            </div>
        </Dialog>
    )
  }
  const handleAddProduct = async () =>{
    setVisible(false)
  }

  const handleViewProduct = async () => {
    //console.log("clicked")
    setViewVisible(false)
  }

  const handleDeleteGroup = async () => {
    if (!selectedRowData) return;
    await apiClient.delete('policy/products/group/'+selectedRowData.easipolSubGroupId, {
      headers: {
        Authorization: 'Bearer ' + (StorageHelper.get('token'))
      }
    }).then((response) => {
      window.location.reload()
      //console.log("Done!")
    })
    //console.log(rowData.easipolSubGroupId)
  }
  
  const globalFilterElement = (
    <div className="relative w-full max-w-xs">
        <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-base-content/50"></i>
        <input
            type="text"
            className="input input-bordered w-full pl-10 h-10 shadow-sm bg-base-100 rounded-full"
            placeholder="Search..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
        />
    </div>
  );

  const header = (
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-center w-full">
          {globalFilterElement}
          <div className="flex items-center gap-3 ml-auto">
              <button className="btn btn-primary rounded-full h-10 min-h-0 shadow-sm px-6" onClick={() => setVisible(true)}>
                  <i className="pi pi-plus"></i> Add New Product
              </button>
              <div className="dropdown dropdown-end">
                  <div tabIndex={0} role="button" className="btn btn-outline btn-ghost h-10 min-h-0 shadow-sm rounded-full">
                      <i className="pi pi-file-export"></i> Export
                  </div>
                  <ul tabIndex={0} className="dropdown-content z-[99] menu p-2 shadow-sm bg-base-100 border border-base-200 rounded-box w-52 mt-2">
                                    <li><a onClick={() => exportToCSV(dt, 'Products')}><i className="pi pi-file-excel text-success"></i> Download CSV</a></li>
                                    <li><a onClick={() => exportToPDF(dt, 'Products', 'Products Report')}><i className="pi pi-file-pdf text-error"></i> Download PDF</a></li>
                                </ul>
              </div>
          </div>
      </div>
  );

    const statusBodyTemplate = (rowData) => {
      const status = rowData.activeStatus;
      if (!status) return <span className="badge border-0 font-semibold text-xs bg-error/10 text-error">Inactive</span>;
      const upperStatus = String(status).toUpperCase();
      let isPositive = upperStatus === 'ACTIVE' || upperStatus === 'TRUE' || upperStatus === '1';
      let label = isPositive ? 'Active' : 'Inactive';
      let bg = isPositive ? 'bg-success/10' : 'bg-error/10';
      let text = isPositive ? 'text-success' : 'text-error';
      return <span className={`badge border-0 font-semibold text-xs ${bg} ${text}`}>{label}</span>;
  };

    return (

    <div className="w-full">
      <AppConfirmDialog
        id="confirm_delete_group_modal"
        title="Delete Product Group"
        message="Are you sure you want to delete this product group? This action cannot be undone."
        onConfirm={handleDeleteGroup}
        confirmLabel="Delete"
        confirmStyle="btn-error text-white"
        icon="pi pi-trash"
      />
      <AppCard title="Active Products List">
      
      {addNewProductTemplate()}

      {viewProductTemplate(selectedRowData)}

      { editProductTemplate(selectedRowData)}

      
        <DataTable ref={dt}
          header={header}
          globalFilter={globalFilter}
          paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          value={productsAvailable.map((item, index) => ({ ...item, index: index + 1 }))}
          emptyMessage="No Products found"
        >
          {cols.map((col, index) => {
            if (col.field === 'actions') {
                return (
                  <Column
                    key={index+'b'}
                    body={renderActions}
                    style={{ textAlign: 'center' }}
                  />
                );
              }
              if (col.field === 'groupImageBannerUrl') {
                return (
                  <Column style={{ width: '3rem' }} key={index} body={imageBodyTemplate} header={col.header} />
                );
              }
              if (col.field === 'easipolPolicySubGroup.planProducts') {
                return (
                  <Column   key={index}  body={productCounter} header={col.header} />
                );
              }
            return <Column key={index+"a"} field={col.field} header={col.header} />;
          })}
        </DataTable>
      </AppCard>
    </div>
  );
}
